import React, { useState } from 'react';
import './index.scss';
import { useSelector } from 'react-redux';
import { RootState } from '@/redux/store';
import { HttpStatusCode } from '@/fetch/core/constant';
import { Col, message, Modal, Row } from 'antd';
import classNames from 'classnames';
import CollectMapApi from '@/fetch/bussiness/collectMap';
import TravelRoutes from '../TravelRoutes';
import CollectRouteMap from '@/components/CollectRouteMap';
import { sendGlobalEvent } from '@/utils/emit';
const fetchApi = new CollectMapApi();
const FinishCollectMap = (props: {
  vehicleName: string;
  cockpitNumber: string;
  bindingState: boolean;
  taskId: number | string;
  subTaskQuantity: number | string;
  heading: number;
  longitude: number;
  latitude: number;
  taskRouteList: any;
  fourLaneIndexList: any;
}) => {
  const { login } = useSelector((state: RootState) => state);
  const {
    cockpitNumber,
    vehicleName,
    taskId,
    subTaskQuantity,
    heading,
    latitude,
    longitude,
    taskRouteList,
    fourLaneIndexList,
  } = props;
  const [modalShow, setModalShow] = useState<boolean>(false);
  const finishCollectMap = async () => {
    try {
      if (!login.userInfo?.userName || !cockpitNumber || !vehicleName) {
        return;
      }
      const res = await fetchApi.finishCollection({
        cockpitNumber,
        vehicleName,
        taskId,
      });
      if (res.code === HttpStatusCode.Success) {
        message.success('采集完成');
        setModalShow(false);
        sendGlobalEvent('click_finish_collect_btn');
      } else {
        message.error(res.message || '网络请求错误');
        return;
      }
    } catch (e) {
      console.error(e);
      return;
    }
  };
  return (
    <>
      <li
        className={classNames('btn-item', {
          'finish-collect-map': props.bindingState,
          'finish-collect-map-disabled': !props.bindingState,
        })}
        onClick={() => {
          if (!props.bindingState) {
            return;
          }
          setModalShow(true);
        }}
      >
        <i>完成采集</i>
      </li>

      {modalShow && (
        <Modal
          title="确认采集完成"
          width={1000}
          open={modalShow}
          onCancel={() => {
            setModalShow(false);
          }}
          onOk={() => finishCollectMap()}
        >
          <div className="finish-collect-modal">
            <p className="confirm-text">
              请确认本次采集是否已完成。一旦确认完成，将无法再继续采集此线路。
            </p>
            <p className="subTask-num">{`子任务数：${
              subTaskQuantity ?? '--'
            }`}</p>
            <Row style={{ height: '450px' }}>
              <Col span={12}>
                <TravelRoutes
                  vehicleName={vehicleName}
                  show={true}
                  latitude={latitude}
                  longitude={longitude}
                  taskId={taskId}
                  rotation={heading}
                  zoom={15}
                />
                <p className="route-title">车辆行驶轨迹</p>
              </Col>
              <Col span={12}>
                <CollectRouteMap
                  latitude={latitude}
                  longitude={longitude}
                  taskRouteList={taskRouteList}
                  fourLaneIndexList={fourLaneIndexList}
                  rotation={heading}
                  id={'finish-modal-collect-map-box'}
                />
                <p className="route-title">规划线路轨迹</p>
              </Col>
            </Row>
          </div>
        </Modal>
      )}
    </>
  );
};

export default React.memo(FinishCollectMap);
